import React from 'react';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import ModalHeader from '../common/modal/header';
import ModalFooter from '../common/modal/footer';

const { classNames } = Mobi2Go.helpers;
const { Order } = Mobi2Go;
const { UI } = Mobi2Go;

export default forwardRefWithTranslation('order.gifting-modal')(
    class GiftingModal extends React.Component {
        state = {
            name: '',
            phone: '',
            message: '',
        };

        name_input = null;

        phone_input = null;

        message_input = null;

        onNameChange = e => {
            const name = `${e.target.value}`.substr(0, 25);
            this.setState({ name }, this.updateOrderComment);
        };

        onPhoneChange = e => {
            const reg = new RegExp('[^0-9]$');
            const phone = e.target.value.replace(reg, '');
            this.setState({ phone }, this.updateOrderComment);
        };

        onMessageChange = e => {
            const message = `${e.target.value}`.substr(0, 125);
            this.setState({ message }, this.updateOrderComment);
        };

        updateOrderComment = () => {
            let comment = '';
            const { name, message, phone } = this.state;
            const { t } = this.props;
            if (name || message || phone) {
                comment += '\n';
                if (name) {
                    comment += t('comment_recipient_name', { name });
                }

                if (phone) {
                    comment += t('comment_recipient_phone', { phone });
                }

                if (message) {
                    comment += t('comment_message', { message });
                }
            }
            Order.setComment(comment);

            Order.setMetadata({
                gifting_recipient_name: name,
                gifting_recipient_phone: phone,
                gifting_recipient_message: message,
            });
        };

        onYesButtonClick = () => {
            if (this.state.name === '') {
                this.name_input.focus();
                return;
            }
            if (this.state.message === '') {
                this.message_input.focus();
                return;
            }
            if (this.state.phone === '') {
                this.phone_input.focus();
                return;
            }

            this.proceed();
        };

        onNoButtonClick = () => {
            this.setState(
                {
                    name: '',
                    phone: '',
                    message: '',
                },
                this.updateOrderComment
            );
            this.proceed();
        };

        proceed = () => {
            this.props.closeModal(true);
            UI.trigger('progressForward', 'gifting');
        };

        render() {
            const is_gifting =
                this.state.name !== '' ||
                this.state.message !== '' ||
                this.state.phone !== '';
            const { t } = this.props;
            return (
                <div>
                    <ModalHeader
                        onClose={this.props.closeModal}
                        headerText={t('header')}
                    />

                    <div className="m2g-modal-body m2g-order-gifting-modal-body">
                        <div className="m2g-icon m2g-icon--gift m2g-order-gifting-modal-icon" />
                        <div
                            className="m2g-input-container m2g-form-element--full-width  m2g-order-gifting-modal-name"
                            data-icon-before
                        >
                            <input
                                type="text"
                                className="m2g-input"
                                placeholder={t('recipient_name')}
                                value={this.state.name}
                                onChange={this.onNameChange}
                                ref={name_input => {
                                    this.name_input = name_input;
                                }}
                            />
                            <span className="m2g-icon m2g-icon--user" />
                        </div>
                        <div
                            className="m2g-input-container m2g-form-element--full-width m2g-order-gifting-modal-phone"
                            data-icon-before
                        >
                            <input
                                type="tel"
                                className="m2g-input"
                                placeholder={t('recipient_phone_number')}
                                value={this.state.phone}
                                onChange={this.onPhoneChange}
                                ref={phone_input => {
                                    this.phone_input = phone_input;
                                }}
                            />
                            <span className="m2g-icon m2g-icon--phone" />
                        </div>
                        <div
                            className="m2g-input-container m2g-form-element--full-width m2g-order-gifting-modal-message"
                            data-icon-before
                        >
                            <input
                                type="text"
                                className="m2g-input"
                                placeholder={t('add_message')}
                                value={this.state.message}
                                onChange={this.onMessageChange}
                                ref={message_input => {
                                    this.message_input = message_input;
                                }}
                            />
                            <span className="m2g-icon m2g-icon--heart" />
                        </div>
                    </div>

                    <ModalFooter>
                        <ModalFooter.Right>
                            {is_gifting && (
                                <button
                                    onClick={this.onYesButtonClick}
                                    className={classNames(
                                        'm2g-button m2g-button--fat m2g-button--primary m2g-order-gifting-modal-yes-button'
                                    )}
                                >
                                    {t('proceed_to_checkout')}
                                </button>
                            )}

                            {!is_gifting && (
                                <button
                                    onClick={this.onNoButtonClick}
                                    className={classNames(
                                        'm2g-button m2g-button--fat m2g-button--primary m2g-order-gifting-modal-no-button'
                                    )}
                                >
                                    {t('skip_not_gift')}
                                </button>
                            )}
                        </ModalFooter.Right>
                    </ModalFooter>
                </div>
            );
        }
    }
);
